<template>
  <div>
    <UploadCustomWithPreview ref="files" :extraData="data.extraData"/>
  </div>
</template>
<script>
import UploadCustomWithPreview from "@/components/images/UploadCustomWithPreview.vue";

export default {
  props: ['data'],
  components: {UploadCustomWithPreview},
  methods: {
    async updateRecord() {
      return new Promise((resolve, reject) => {
        this.$refs.files.$refs.upload.active = true;
        let checkInterval = setInterval(async () => {
          if (!this.$refs.files.$refs.upload.active) {
            clearInterval(checkInterval);
            const uploadCheck = this.$refs.files.$refs.upload.files.find((f) => !f.success);
            if (uploadCheck) {
              toastr['warning']('некоторые файлы не загружены', 'Неуспешно')
            } else {
              resolve({success: true});
              // toastr['success']('Файлы загружены', 'Успешно');
            }
          }
        }, 1000)
      })
    }
  }
}
</script>
